import React from 'react';

const FireFlowFlowHydrantTableRow = ({ number, flowHydrant }) => {

  return (
    <tr>
      <td>{number}:</td>
      <td>{flowHydrant?.flowHydrant}</td>
      <td>{flowHydrant?.flowDevice}</td>
      <td>{flowHydrant?.diameter}</td>
      <td>{flowHydrant?.gpm}</td>
      <td>{flowHydrant?.gallonsUsed}</td>
    </tr>
  );
};

export default FireFlowFlowHydrantTableRow;